"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require("react");
var ReactDOM = require("react-dom");

var TableRow = function (_React$Component) {
  _inherits(TableRow, _React$Component);

  function TableRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TableRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseOver = function () {
      if (_this.props.onRowHover) {
        _this.props.onRowHover(_this.props.index);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TableRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._listenerId = this.props.contextMenu.addListener(ReactDOM.findDOMNode(this), this.props.getRowMenuItems([this.props.index], function () {
        _this2.props.contextMenu.update(_this2._listenerId);
      }), this.props.contextMenu.RIGHT_CLICK);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      this.props.contextMenu.removeListener(this._listenerId);
      this._listenerId = this.props.contextMenu.addListener(ReactDOM.findDOMNode(this), this.props.getRowMenuItems([this.props.index], function () {
        _this3.props.contextMenu.update(_this3._listenerId);
      }), this.props.contextMenu.RIGHT_CLICK);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.contextMenu.removeListener(this._listenerId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      return React.createElement(
        "div",
        {
          draggable: true,
          onDragStart: function onDragStart(event) {
            if (_this4.props.onDragStart) {
              _this4.props.onDragStart(_this4.props.index, event);
            }
          },
          onClick: function onClick(event) {
            return _this4.props.onSelect(_this4.props.index, _this4.props.rowData, event);
          },
          className: this.props.className,
          key: this.props.rowKey,
          style: this.props.style,
          onMouseOver: this.onMouseOver
        },
        this.props.columns,
        this.props.hoverButton
      );
    }
  }]);

  return TableRow;
}(React.Component);

module.exports = TableRow;